import { useAgentPanelState, useToggleAgentPanelShortcut } from '@/app/agentConversation/_hooks';
import { isAgentChatEnabled } from '@/helpers/featureFlags';

import AgentPanelContext from '@/app/agentConversation/_context';
import { useSelf } from '@/data/user';

// What every consumer reads for a user without the feature: the panel closed
// and nothing to do. A constant, so it never changes identity.
const DISABLED_PANEL = Object.freeze({ isEnabled: false, isOpen: false });

/**
 * Wraps the signed-in app so the assistant panel and the nav button that opens
 * it share one state, which survives navigation.
 *
 * For a user without the feature nothing of the panel runs — no localStorage
 * read or write, no `--agent-w`, no shortcut listener, no request. The branch
 * is stable for the session: `/self` is loaded before this mounts
 * (UserAuthentication gates on it) and a username does not change.
 */
const AgentPanelProvider = ({ children }) => {
  const self = useSelf(false);
  if (!isAgentChatEnabled(self.data)) {
    return <AgentPanelContext.Provider value={DISABLED_PANEL}>{children}</AgentPanelContext.Provider>;
  }
  return <EnabledAgentPanelProvider>{children}</EnabledAgentPanelProvider>;
};

const EnabledAgentPanelProvider = ({ children }) => {
  const panel = useAgentPanelState();
  useToggleAgentPanelShortcut(panel.toggle);

  return <AgentPanelContext.Provider value={panel}>{children}</AgentPanelContext.Provider>;
};

export default AgentPanelProvider;
